import { unref } from 'vue';

import i18n from '@/config/i18n';

const SUPPORTED_HC_LOCALES = new Set(['en', 'es', 'fr', 'de']);

const getHcLocale = (): string => {
  const userLocale = unref(i18n.global.locale) ?? 'en';
  return SUPPORTED_HC_LOCALES.has(userLocale) ? userLocale : 'en';
};

export const getHcMainUrl = (): string => `https://support.thehotelsnetwork.com/${getHcLocale()}`;

export const getHcBenchdirect = (): string => `${getHcMainUrl()}/collections/13384016-benchdirect`;

export const getHcOpportunitiesLos = (): string => `${getHcMainUrl()}/articles/11508239-opportunity-4-increase-your-length-of-stay-los`;
export const getHcOpportunitiesWebsiteTraffic = (): string => `${getHcMainUrl()}/articles/11513062-opportunity-6-increase-the-efficiency-of-your-website-traffic`;
export const getHcOpportunitiesBeConversion = (): string => `${getHcMainUrl()}/articles/11495217-opportunity-3-increase-your-visitor-to-booking-engine-be-conversion`;
export const getHcOpportunitiesBeToBookingConversionRate = (): string => `${getHcMainUrl()}/articles/11494221-opportunity-1-increase-your-be-to-booking-conversion-rate`;
export const getHcOpportunitiesAbv = (): string => `${getHcMainUrl()}/articles/11496352-opportunity-7-increase-your-abv`;
export const getHcOpportunitiesAdr = (): string => `${getHcMainUrl()}/articles/11495828-opportunity-5-increase-your-adr`;
export const getHcOpportunitiesDisparity = (): string => `${getHcMainUrl()}/articles/11508113-opportunity-2-decrease-your-disparity-frequency`;

export const getHcUnderstandingBenchdirectMetrics = (): string => `${getHcMainUrl()}/articles/11508561-understaning-benchdirect-metrics#h_bd17d73479`;
